import React from 'react'
import './About.css'
import img from './img/About.png'


function About() {
  return (
    <div className='About'>
            
        <div className="about-container">
            
            <div className="about-text">
                <h1>About</h1>
                <p> "Cool Bastards" is the story of the little monkeys trying to figure out who their real parents are! <br/>
                     Save their life by minting them and adopt them as your kids and see how these babies will turn your life around! <br/>
                    
        
                   
              
                    
                    
                    There is only 6999 Cool Bastards <br/>
                    Max 12 NFTs per wallet <br/>
                    Max 10 NFTs per tx <br/>
                    There is only 4000 free NFTs, unless some of you bastards are cool enough, 0.002E for each. <br/>



                    Pssssssstttt: No roadmap, only surprises! CCO, so you can use your Cool Bastards however you want! <br/>
                    
                    </p>
                <a href="https://opensea.io/collection/coolbastards" target="_blank" className="Btn">Opensea</ a>

                </div>

            <div className="about-img">
                <img src={img} alt="" />

            </div>
            
            
            </div>        
        
        
        </div>
  )
}

export default About